import { useCallback, useState } from 'react'

import { IAboutPlatformBll } from './types'

export const useInitialState = (): IAboutPlatformBll => {
  const [collapse, setCollapse] = useState(false)

  const handleClickCollapse = useCallback(() => {
    setCollapse(true)
  }, [collapse])

  return {
    collapse,
    handleClickCollapse,
  }
}
